import React from 'react';
import { Breadcrumbs } from '../components/ui/Breadcrumbs';
import { useLanguage } from '../i18n/LanguageContext';
interface TermsPageProps {
  onNavigate: (page: string) => void;
}
export function TermsPage({
  onNavigate
}: TermsPageProps) {
  const {
    t
  } = useLanguage();
  return <div className="min-h-screen bg-slate-50 pb-24" data-id="element-25989">
      <div className="bg-white border-b border-slate-200 pt-6 pb-12" data-id="element-25990">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25991">
          <Breadcrumbs items={[{
          label: t('legal.backToHome'),
          onClick: () => onNavigate('home')
        }, {
          label: t('legal.terms.title')
        }]} className="mb-8" data-id="element-25992" />
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4" data-id="element-25993">
            {t('legal.terms.title')}
          </h1>
          <p className="text-slate-500" data-id="element-25994">{t('legal.lastUpdated')}</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-25995">
        <div className="bg-white rounded-2xl p-8 sm:p-12 border border-slate-200 shadow-sm prose prose-slate max-w-none" data-id="element-25996">
          <h2 data-id="element-25997">{t('legal.terms.s1.title')}</h2>
          <p data-id="element-25998">{t('legal.terms.s1.p1')}</p>

          <h2 data-id="element-25999">{t('legal.terms.s2.title')}</h2>
          <p data-id="element-26000">{t('legal.terms.s2.p1')}</p>
          <p data-id="element-26001">
            <strong data-id="element-26002">{t('legal.terms.s2.p2').split(':')[0]}:</strong>{' '}
            {t('legal.terms.s2.p2').split(':')[1]}
          </p>

          <h2 data-id="element-26003">{t('legal.terms.s3.title')}</h2>
          <p data-id="element-26004">{t('legal.terms.s3.p1')}</p>

          <h2 data-id="element-26005">{t('legal.terms.s4.title')}</h2>
          <p data-id="element-26006">{t('legal.terms.s4.p1')}</p>
          <p data-id="element-26007">{t('legal.terms.s4.p2')}</p>

          <h2 data-id="element-26008">{t('legal.terms.s5.title')}</h2>
          <p data-id="element-26009">{t('legal.terms.s5.p1')}</p>
          <ul data-id="element-26010">
            <li data-id="element-26011">{t('legal.terms.s5.l1')}</li>
            <li data-id="element-26012">{t('legal.terms.s5.l2')}</li>
            <li data-id="element-26013">{t('legal.terms.s5.l3')}</li>
          </ul>

          <h2 data-id="element-26014">{t('legal.terms.s6.title')}</h2>
          <p data-id="element-26015">{t('legal.terms.s6.p1')}</p>

          <h2 data-id="element-26016">{t('legal.terms.s7.title')}</h2>
          <p data-id="element-26017">{t('legal.terms.s7.p1')}</p>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm" data-id="element-26018">
          <button onClick={() => onNavigate('privacy')} className="text-indigo-600 hover:text-indigo-800 font-medium transition-colors" data-id="element-26019">
            {t('legal.privacy.title')} →
          </button>
          <button onClick={() => onNavigate('contact')} className="text-slate-500 hover:text-slate-700 font-medium transition-colors" data-id="element-26020">
            {t('legal.contactUs')}
          </button>
        </div>
      </div>
    </div>;
}